export default "__VITE_ASSET__BDfv5C0T__"